import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Card, Tabs, Tab, ButtonGroup, Button } from "react-bootstrap";
import { httpGet } from "../../../utility/requestHelper";
import { unifiedEnvConfig } from "../../../constants/api-endpoint";
import { NoFeedIcon, TwitterIcon, TwitterWBIcon } from "../../Icons/icons.component";
import {
  TAB,
  VERTICALS,
  APP_CONSTANTS,
  SOCIAL_SOURCES,
} from "../../../constants/app-constant";
import SingleTwitterFeed from "./SingleTwitterFeed";
import Loader from "../../Shared/Loader";
import "../../Dashboard/style.sass";
import TwitterFeedsModal from "./TwitterFeedModal";
import moment from "moment";

const TwitterFeeds = ({
  endRange,
  startRange,
  widgetList,
  setTopicId,
  selectedFilter,
  setSelectedFilter,
  tabData,
  setTabData,
  setWidgetApiInProgress,
  widgetApiInProgress,
  setOptList,
  topicList,
  setTopicList,
}) => {
  const { V_SOCIAL, V_BLOG, V_FORUM, TWITTER_INSIGHTS } = VERTICALS;
  const [apiInProgress, setApiInProgress] = useState(false);
  const [tabKey, setTabKey] = useState(TAB[0].toLowerCase());
  const [vertical, setVertical] = useState(TWITTER_INSIGHTS);
  const [showModal, setShowModal] = useState(false);
  const [feedsToShare, setFeedsToshare] = useState([]);

  const selectedEntity =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.selectedEntity
    ) || null;

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  let tempList = [];
  useEffect(() => {
    if (startRange && endRange && selectedFilter && selectedFilter.value) {
      getTwitterFeeds(selectedFilter.value);
    }
  }, [startRange, endRange]);
  useEffect(() => {
    if (selectedFilter && selectedFilter.value) {
      getTwitterFeeds(selectedFilter.value);
    }
  }, [selectedFilter]);
  const handleSelectedFeeds = (feed) => {
    const selectedElm = feedsToShare.filter((n) => n.id == feed.id);
    if (selectedElm && selectedElm[0]) {
      setFeedsToshare(feedsToShare.filter((n) => n.id != selectedElm[0].id));
    } else {
      setFeedsToshare([...feedsToShare, feed]);
    }
  };

  useEffect(() => {
    const fromDate = moment(startRange).format("MM/DD/YYYY");
    const toDate = moment(endRange).format("MM/DD/YYYY");
    setApiInProgress(true);
    httpGet(
      `${unifiedEnvConfig.FETCH_ALL_TOPICS}?client_id=${selectedClient.id}`
    ).then((res) => {
      setSelectedFilter(
        res.data.data.map(({ name, id }) => {
          return {
            value: id,
            label: name,
          };
        })[0]
      );
      setTopicList(res.data.data);
      setTopicId(res.data.data.map(({ id }) => id)[0]);
      setWidgetApiInProgress(true);
      setApiInProgress(false);
    });
  }, []);

  useEffect(() => {
    if (selectedFilter) {
      const id = topicList.filter(({ id }) => {
        if (id === selectedFilter.value) {
          return id;
        }
      });
      setTopicId(id.map(({ id }) => id));
    }
  }, [selectedFilter]);

  useEffect(() => {
    setOptList(
      topicList.length &&
        topicList.map(({ name, id }) => {
          return {
            value: id,
            label: name,
          };
        })
    );
  }, [topicList]);

  const renderTabData = () => {
    return TAB.map((item, index) => {
      const allArticleList =
        selectedFilter &&
        tabData.map(
          (e) =>
            `${SOCIAL_SOURCES.TWITTER}/${e.id}?entityName="${selectedFilter.label}"`
        );

      if (tabData) {
        return (
          <Tab
            key={index}
            eventKey={item.toLowerCase()}
            title={`${item}`}
            className="cardTopab"
          >
            {tabData && tabData.length ? (
              <>
                {tabData
                  .map((item, idx) => {
                    return (
                      <SingleTwitterFeed
                        key={item.id}
                        {...item}
                        checked={false}
                        topicType={vertical}
                        onFeedSelect={handleSelectedFeeds}
                        selectedVertical={vertical}
                        clientId={selectedClient.id}
                        feedsToShare={feedsToShare}
                        allArticleList={allArticleList}
                        selectedFilter={selectedFilter}
                      />
                    );
                  })
                  .slice(0, 2)}
                {tabData.length > 2 ? renderViewAll() : null}
              </>
            ) : (
              <div
                className="noFilterDataWrap no-feeds"
                style={{ width: "100%" }}
              >
                <NoFeedIcon size="sm" />
                <h6>No Feeds Found</h6>
              </div>
            )}
          </Tab>
        );
      }
    });
  };

  const getTwitterFeeds = (topicId) => {
    const fromDate = moment(startRange).format("MM/DD/YYYY");
    const toDate = moment(endRange).format("MM/DD/YYYY");
    setApiInProgress(true);
    if (topicId) {
      httpGet(
        `${unifiedEnvConfig.TWITTER_FEEDS}?topic_id=${topicId}&client_id=${selectedClient.id}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}`
        // `https://cbiu.weboapps.com?topic_id=${27}&client_id=${
        //   selectedClient.id
        // }&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}`
      )
        .then((response) => {
          setApiInProgress(false);
          const {
            data: { data },
          } = response;
          setTabData(data);
        })
        .catch((e) => {
          if (e.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
            setApiInProgress(true);
          } else {
            setApiInProgress(false);
          }
        });
    }

    //Pagination topRetweet may required in future..

    // if (topicId) {
    //   httpGet(
    //     `${unifiedEnvConfig.TWITTER_FEEDS}?client_id=${selectedClient.id}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}&searchParams[page]=10&searchParams[perPage]=1&topic_id=${topicId}`
    //   )
    //     .then((response) => {
    //       setApiInProgress(false);
    //       const {
    //         data: { data },
    //       } = response;
    //       // setTabData(data);
    //       // console.log(data);
    //     })
    //     .catch((e) => {
    //       if (e.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
    //         setApiInProgress(true);
    //       } else {
    //         setApiInProgress(false);
    //       }
    //     });
    // }
  };

  const renderViewAll = () => {
    return (
      <div className="view-all-button" onClick={() => setShowModal(true)}>
        View All
      </div>
    );
  };

  const setVerticalValue = (topic) => {
    setVertical((prevState) => parseInt(topic, 10));
  };

  const handleVerticalClick = (verticalValue) => {
    if (verticalValue) {
      setFeedsToshare([]);
      setVerticalValue(verticalValue);
      setTabKey(TAB[0].toLowerCase());

      setApiInProgress(false);
    }
  };

  const handleTabClick = (tab) => {
    setFeedsToshare([]);
    setTabKey(tab);
  };

  return (
    <>
      {/* {dropDown()} */}
      {showModal && selectedClient.id ? (
        <TwitterFeedsModal
          show={showModal}
          onCancel={setShowModal}
          clientId={selectedClient.id}
          handleTabClick={handleTabClick}
          handleVerticalClick={handleVerticalClick}
          selectedVertical={vertical}
          selectedTabKey={tabKey}
          tabData={tabData}
          startRange={startRange}
          endRange={endRange}
          selectedFilter={selectedFilter}
          topicId={selectedFilter.value}
        />
      ) : null}
      <Card className="cardWrap cls-tfa" body>
        <div className="cardTopa">
          <ButtonGroup
            className="smallToggleBtnGroup"
            onClick={(e) => handleVerticalClick(e.target.value)}
          >
            <Button
              className={
                vertical === TWITTER_INSIGHTS ? "tagBlue active" : "tagBlue"
              }
              value={TWITTER_INSIGHTS}
            >
              <TwitterWBIcon />
              X
            </Button>
          </ButtonGroup>
          {/* <ShareArticle
            article={feedsToShare}
            isSocial={vertical === TWITTER_INSIGHTS}
            onShareSuccess={() => setFeedsToshare([])}
          /> */}
        </div>
        {
          <React.Fragment key={tabKey}>
            {apiInProgress ? (
              <Loader />
            ) : (
              <>
                <Tabs
                  activeKey={tabKey}
                  transition={false}
                  onSelect={(k) => handleTabClick(k)}
                  className="cardTopab"
                >
                  {renderTabData()}
                </Tabs>
              </>
            )}
          </React.Fragment>
        }
      </Card>
    </>
  );
};

export default TwitterFeeds;
